import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const FAQSection = ({ initialData = [], onChange }) => {
  const [faqs, setFaqs] = useState(initialData);

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });

  const [editingId, setEditingId] = useState(null);

  // Sync when initialData changes
  useEffect(() => {
    setFaqs(initialData);
  }, [initialData]);

  const syncFaqs = (updatedFaqs) => {
    setFaqs(updatedFaqs);
    if (onChange) {
      onChange(updatedFaqs);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    if (!formData.question.trim() || !formData.answer.trim()) {
      toast.error("Please fill both Question and Answer.");
      return;
    }

    if (editingId) {
      // Update FAQ
      const updated = faqs.map((item) =>
        item.id === editingId ? { ...item, ...formData } : item
      );
      syncFaqs(updated);
      toast.success("FAQ updated");
    } else {
      // Add FAQ
      const newFaq = {
        id: Date.now(),
        ...formData,
      };
      const updated = [...faqs, newFaq];
      syncFaqs(updated);
      toast.success("FAQ added");
    }

    setFormData({
      question: "",
      answer: "",
    });
    setEditingId(null);
  };

  const handleEdit = (faq) => {
    setEditingId(faq.id);
    setFormData({
      question: faq.question,
      answer: faq.answer,
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete this FAQ?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = faqs.filter((item) => item.id !== id);
        syncFaqs(updated);
        toast.success("FAQ deleted");
      }
    });
  };

  const handleCancel = () => {
    setEditingId(null);
    setFormData({
      question: "",
      answer: "",
    });
  };

  return (
    <div className="mt-4">
      <h4 className="mb-3">FAQ Section</h4>

      {/* List */}
      <div className="card mb-4">
        <div className="card-header">FAQs</div>
        <div className="card-body">
          {faqs.length === 0 ? (
            <p className="mb-0 text-muted">No FAQs added yet.</p>
          ) : (
            <div className="accordion" id="faqAccordion">
              {faqs.map((faq, index) => (
                <div className="accordion-item" key={faq.id}>
                  <h2 className="accordion-header" id={`heading-${faq.id}`}>
                    <button
                      className={`accordion-button ${
                        index !== 0 ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-${faq.id}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`collapse-${faq.id}`}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse-${faq.id}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                    aria-labelledby={`heading-${faq.id}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body d-flex justify-content-between align-items-start gap-3">
                      <div>{faq.answer}</div>
                      <div className="btn-group btn-group-sm ms-2 flex-shrink-0">
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={() => handleEdit(faq)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => handleDelete(faq.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Form */}
      <div className="card">
        <div className="card-header">
          {editingId ? "Edit FAQ" : "Add New FAQ"}
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label">Question</label>
              <input
                type="text"
                name="question"
                className="form-control"
                placeholder="Enter question"
                value={formData.question}
                onChange={handleChange}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Answer</label>
              <textarea
                name="answer"
                className="form-control"
                rows="3"
                placeholder="Enter answer"
                value={formData.answer}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="mt-3 d-flex gap-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {editingId ? "Update FAQ" : "Add FAQ"}
            </button>
            {editingId && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
